import {
  __experimentalToolsPanel as ToolsPanel,
  __experimentalToolsPanelItem as ToolsPanelItem,
  TextControl,
  ToggleControl,
  __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from "@wordpress/components";
import {
  PanelColorSettings,
  __experimentalSpacingSizesControl as SpacingSizesControl,
} from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
import State from "./State";

export default function AllInspectorSettings({ attributes, setAttributes }) {
  const {
    backgroundColor,
    backgroundColorHover,
    backgroundColorActive,
    textColor,
    textColorHover,
    textColorActive,
    iconSize,
    iconPosition,
    iconGap,
  } = attributes;

  const useIcon = attributes.useIcon ?? true;

  return (
    <>
      <PanelColorSettings
        title={__("Colors", "brandy-blocks")}
        initialOpen={false}
        enableAlpha={true}
        colorSettings={[
          {
            value: backgroundColor,
            onChange: (newColor) =>
              setAttributes({
                backgroundColor: newColor,
              }),
            clearable: true,
            label: __("Background default", "brandy-blocks"),
          },
          {
            value: backgroundColorHover,
            onChange: (newColor) =>
              setAttributes({
                backgroundColorHover: newColor,
              }),
            clearable: true,
            label: __("Background hover", "brandy-blocks"),
          },
          {
            value: backgroundColorActive,
            onChange: (newColor) =>
              setAttributes({
                backgroundColorActive: newColor,
              }),
            label: __("Background active", "brandy-blocks"),
          },
          {
            value: textColor,
            onChange: (newColor) =>
              setAttributes({
                textColor: newColor,
              }),
            label: __("Text default", "brandy-blocks"),
          },
          {
            value: textColorHover,
            onChange: (newColor) =>
              setAttributes({
                textColorHover: newColor,
              }),
            label: __("Text hover", "brandy-blocks"),
          },
          {
            value: textColorActive,
            onChange: (newColor) =>
              setAttributes({
                textColorActive: newColor,
              }),
            label: __("Text active", "brandy-blocks"),
          },
        ]}
      />
      <ToolsPanel label={__("Settings")}>
        <ToolsPanelItem
          hasValue={() => iconPosition !== "left"}
          label={__("Use icon")}
          onDeselect={() => setAttributes({ useIcon: true })}
          isShownByDefault
        >
          <ToggleControl
            label={__("Use icon", "brandy-blocks")}
            checked={useIcon}
            onChange={(value) => setAttributes({ useIcon: value })}
          />
        </ToolsPanelItem>
        <ToolsPanelItem
          hasValue={() => iconPosition !== "left"}
          label={__("Icon position")}
          onDeselect={() => setAttributes({ iconPosition: "left" })}
          isShownByDefault
        >
          <ToggleGroupControl
            value={iconPosition}
            onChange={(value) => setAttributes({ iconPosition: value })}
            isBlock
            label={__("Icon position", "brandy-blocks")}
            __nextHasNoMarginBottom
            __next40pxDefaultSize
          >
            <ToggleGroupControlOption
              value="left"
              label={__("Left", "brandy-blocks")}
            />
            <ToggleGroupControlOption
              value="right"
              label={__("Right", "brandy-blocks")}
            />
          </ToggleGroupControl>
        </ToolsPanelItem>
        <ToolsPanelItem
          hasValue={() => iconSize !== "24px"}
          label={__("Icon size")}
          onDeselect={() => setAttributes({ iconSize: "24px" })}
          isShownByDefault
        >
          <SpacingSizesControl
            label={__("Icon size")}
            min={0}
            onChange={(value) =>
              setAttributes({
                iconSize: value.top,
              })
            }
            showSideInLabel={false}
            sides={["top"]}
            values={{ top: iconSize }}
            allowReset={false}
          />
        </ToolsPanelItem>
        <ToolsPanelItem
          hasValue={() => iconGap !== "4px"}
          label={__("Icon gap")}
          onDeselect={() => setAttributes({ iconGap: "4px" })}
          isShownByDefault
        >
          <SpacingSizesControl
            label={__("Icon gap")}
            min={0}
            onChange={(value) =>
              setAttributes({
                iconGap: value.top,
              })
            }
            showSideInLabel={false}
            sides={["top"]}
            values={{ top: iconGap }}
            allowReset={false}
          />
        </ToolsPanelItem>
        <ToolsPanelItem
          hasValue={() => attributes.defaultText !== ""}
          label={__("Text")}
          onDeselect={() => setAttributes({ defaultText: "" })}
          isShownByDefault
        >
          <TextControl
            __nextHasNoMarginBottom
            __next40pxDefaultSize={true}
            label="Text"
            help="Leave it empty to hide"
            value={attributes.defaultText ?? ""}
            onChange={(value) => setAttributes({ defaultText: value })}
          />
        </ToolsPanelItem>
        <ToolsPanelItem
          hasValue={() => attributes.addedText !== ""}
          label={__("Added Text")}
          onDeselect={() => setAttributes({ addedText: "" })}
          isShownByDefault
        >
          <TextControl
            __nextHasNoMarginBottom
            __next40pxDefaultSize={true}
            label="Added Text"
            help="Leave it empty to hide"
            value={attributes.addedText ?? ""}
            onChange={(value) => setAttributes({ addedText: value })}
          />
        </ToolsPanelItem>
      </ToolsPanel>
      {useIcon && (
        <>
          <State
            attributes={attributes}
            setAttributes={setAttributes}
            state="default"
          />
          <State
            attributes={attributes}
            setAttributes={setAttributes}
            state="hover"
          />
          <State
            attributes={attributes}
            setAttributes={setAttributes}
            state="active"
          />
        </>
      )}
    </>
  );
}
